import clsx from 'clsx';
import React from 'react';
import styles from './Card.module.scss';

interface CardProps {
    children?: React.ReactNode;
    className?: string;
}

export const Card: React.FC<CardProps> = ({ children, className }) => {
    return <div className={clsx(styles.root, className)}>{children}</div>;
};
